import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Visualise = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { wallpaperUrl } = location.state || {};

  if (!wallpaperUrl) {
    return <div className="text-center p-8">No wallpaper to preview.</div>;
  }

  const handleAddAndBack = () => {
    navigate(-1, {
      state: {
        addToBasket: true
      }
    });
  };

  return (
    <div className="flex flex-col items-center p-4">
      <h2 className="text-xl font-semibold mb-4">Visualise Your Wallpaper</h2>

      <div className="flex flex-col md:flex-row gap-8 items-center justify-center">
        {/* Front View Mockup */}
        <div className="relative w-[200px] h-[400px] rounded-[2.5rem] bg-black shadow-inner border-2 border-gray-700 overflow-hidden">
          <img
            src={wallpaperUrl}
            alt="Wallpaper preview on screen"
            className="w-full h-full object-cover"
          />
          {/* Status bar icons */}
          <div className="absolute top-2 left-4 text-white text-xs font-mono opacity-80">
            4G ▪︎ 🔋 87%
          </div>
          {/* Speaker slot */}
          <div className="absolute top-1 left-1/2 -translate-x-1/2 w-16 h-1.5 rounded bg-gray-300 opacity-70" />
          {/* Date & Time overlay */}
          <div className="absolute top-10 left-0 right-0 text-center text-white font-mono text-sm drop-shadow">
            09:41<br />Monday 8 May
          </div>
          {/* Fake message bubble */}
          <div className="absolute bottom-6 left-4 max-w-[150px] bg-white/80 text-black text-sm px-3 py-2 rounded-2xl shadow-md">
            “Can’t believe how good this wallpaper looks!”
          </div>
        </div>

        {/* Back Case View */}
        <div className="relative w-[200px] h-[400px] rounded-[2.5rem] bg-gray-100 shadow-inner border-2 border-gray-700 overflow-hidden">
          <img
            src={wallpaperUrl}
            alt="Wallpaper preview on case"
            className="w-full h-full object-cover"
          />
          {/* Camera cutout */}
          <div className="absolute top-6 right-6 w-12 h-12 bg-black/60 rounded-full border-2 border-white shadow-md" />
          <div className="absolute top-8 right-8 w-4 h-4 bg-white rounded-full shadow-sm" />
        </div>
      </div>

      <div className="flex gap-4 mt-6">
        <button
          onClick={handleAddAndBack}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
        >
          Add to Basket
        </button>
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-300 text-gray-800 px-6 py-2 rounded hover:bg-gray-400"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default Visualise;

